import { useProducts } from '@/data/product';
import Grid from '@/components/product/grid';
import { useRouter } from 'next/router';
import { sortables } from '@/lib/constants';
import { useProductLoader } from '../product/product-loader';
import { trackEvent } from '@/data/utils/utils';
import { SortOrder } from '@/types';

export default function SearchResults({ searchText }: { searchText: string }) {
  const router = useRouter();
  const { setIsLoading, isLoading } = useProductLoader();
  const sortable =
    sortables.find((sortable) => sortable.value === router.query.orderBy) ??
    sortables[0];
  const { products, loadMore, hasNextPage, isLoadingMore } = useProducts(
    {
      ...router.query,
      name: searchText,
      orderBy: sortable.orderBy,
      sortedBy: sortable.sortedBy as SortOrder,
    },
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        if(searchText)
        trackEvent('search_items', {
          search_term: router.query.search,
          orderBy: sortable.orderBy,
          sortedBy: sortable.sortedBy,
          ...router.query,          
          // TODO: add more data and maybe move to useProducts?
          // results_count: data?.pages.length
          // totalItems: data?.pages,
          // total: data.total,
          // items: data?.pages.,
        });
      },
      onSettled: (data) => {
        setIsLoading(false);
      },
    }
    // {
    //   enabled: Boolean(searchText),
    // }
  );
  return (
    <Grid
      products={products}
      onLoadMore={loadMore}
      hasNextPage={hasNextPage}
      isLoadingMore={isLoadingMore}
      isLoading={isLoading}
      // disableAutoLoad={!router.query?.search && !router.query?.categories}
    />
  );
}
